// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

// This is a special compiler for labels in a form that are used like buttons and need a manual confirmation
// from the user before triggering a change event on a hidden input field.
// Provide the prompt text with `'up-data': { confirm_prompt: 'sure?' }`
up.compiler('label[confirm-delete]', (element, data) => {
  function confirmSubmission() {
    const hiddenInputId = element.getAttribute('for')
    const hiddenInput = element.closest('form').querySelector(`#${hiddenInputId}`)

    // wait one tick so the checkbox is checked before submitting the form
    setTimeout(() => {
      up.emit(hiddenInput, 'change')
    }, 0)
  }

  element.addEventListener('click', (e) => {
    if (confirm(data.confirm_prompt) === true) {
      confirmSubmission()
    } else {
      up.event.halt(event)
    }
  })
})
